import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles/App.scss";
import "./styles/globalStyles.scss";

import { ThemeProvider } from "../src/context/theme-context";

// Suppress React Bootstrap defaultProps warnings
const originalError = console.error;
console.error = (...args) => {
  if (typeof args[0] === 'string' && args[0].includes('defaultProps will be removed')) {
    return;
  }
  originalError(...args);
};

const container = document.getElementById("app");
const root = createRoot(container!);
root.render(
  <ThemeProvider>
    <App />
  </ThemeProvider>,
);